import React, { useEffect, useState } from 'react';

const DOT_INTERVAL_MS = 500;
const MAX_DOTS = 3;

/** Cycles "." → ".." → "..." → "." — a lightweight, decorative stand-in for a spinner next to text that
 * already says what is happening (the caller's own label carries the meaning for screen readers). */
export const AnimatedEllipsis: React.FC = () => {
    const [dots, setDots] = useState(1);

    useEffect(() => {
        const id = setInterval(() => setDots(d => (d % MAX_DOTS) + 1), DOT_INTERVAL_MS);
        return () => clearInterval(id);
    }, []);

    return <span aria-hidden="true" data-testid="animated-ellipsis">{'.'.repeat(dots)}</span>;
};
